/**
 * Profile hero themes (GH-826, finalized in GH-849).
 *
 * The nine official themes users can pick in the Manage Profile & Theme
 * modal. Slugs are stored in users.profile_theme and validated against
 * config/profile-themes.php — keep the two lists in sync when adding a theme.
 * Unknown or missing slugs fall back to the default via resolveProfileTheme().
 *
 * Values come from the finalized Figma frame (Mockups node 224-2649). Each
 * theme carries its own gradient angle/stops plus theme-specific decoration
 * colors: `wedge` is the solid corner triangle on the left, `shade` is the
 * translucent diagonal band on the right. The decoration geometry itself is
 * fixed (dx/dy ≈ 0.91 diagonal, see ProfileHero.vue) — only colors vary.
 */
export const DEFAULT_PROFILE_THEME = "hero-default";

export const profileThemes = {
    "hero-default": {
        label: "Hero Default",
        gradient: "linear-gradient(221.7deg, #ffb545 17.33%, #f21439 69.81%)",
        shade: "rgba(242, 20, 57, 0.6)",
        wedge: "#ffb545",
    },
    "miami-night": {
        label: "Miami Night",
        gradient: "linear-gradient(206.25deg, #eb2eb3 20.76%, #48057c 81.87%)",
        shade: "rgba(86, 7, 93, 0.4)",
        wedge: "#ff7b2a",
    },
    "happy-robot": {
        label: "Happy Robot",
        gradient: "linear-gradient(228.66deg, #00cf7c 28.18%, #064db8 76.12%)",
        shade: "rgba(0, 99, 197, 0.6)",
        wedge: "#ffb545",
    },
    charcoal: {
        label: "Charcoal",
        gradient: "linear-gradient(206.25deg, #413847 20.76%, #201c23 81.87%)",
        shade: "rgba(19, 13, 19, 0.4)",
        wedge: "#3f3843",
    },
    sunset: {
        label: "Sunset",
        gradient: "linear-gradient(216.85deg, #ff7944 22.05%, #b1058b 74.93%)",
        shade: "rgba(195, 0, 107, 0.6)",
        wedge: "#eb2eb3",
    },
    lakehouse: {
        label: "Lakehouse",
        gradient: "linear-gradient(218.25deg, #2e77ff 27.58%, #2123bb 76.53%)",
        shade: "rgba(20, 30, 182, 0.4)",
        wedge: "#3ebbff",
    },
    "lemon-lime": {
        label: "Lemon Lime",
        gradient: "linear-gradient(218.25deg, #9fde00 27.58%, #1b8704 76.53%)",
        shade: "rgba(57, 155, 3, 0.6)",
        wedge: "#e6f118",
    },
    neo: {
        label: "Neo",
        gradient: "linear-gradient(205.47deg, #00882b 1.06%, #032422 72.19%)",
        shade: "rgba(2, 41, 39, 0.4)",
        wedge: "#34b800",
    },
    "after-party": {
        label: "After Party",
        gradient: "linear-gradient(206.25deg, #2d0d94 20.76%, #0a021e 81.87%)",
        shade: "rgba(9, 2, 32, 0.4)",
        wedge: "#bf00ff",
    },
};

export function resolveProfileTheme(key) {
    return profileThemes[key] ?? profileThemes[DEFAULT_PROFILE_THEME];
}
